module.exports = __webpack_public_path__ + "static/media/Js-logos.45a3d810.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/Coding/assets/Js-logos.svg
// module id = 51
// module chunks = 0